<template>
  <div class="page-login">
    <!-- 加载进度圆圈 -->
    <div class="login-index-loading-box" v-if="isLoading">
      <v-progress-circular
        :size="140"
        :width="5"
        color="#6A1B9A"
        indeterminate
      ></v-progress-circular>
      <h3 class="loading-style">Loading...</h3>
    </div>
    <!-- 登录界面 -->
    <div class="login-index" v-else>
      <!-- header start -->
      <div class="header-box">
        <div class="container header-content">
          <div class="website-name">
            <div class="logo"></div>
            <div class="text-wrap">
              <div class="title">国家卫生健康委智慧健康服务平台</div>
              <div class="sub-title">国家卫生健康委医疗机构印鉴卡系统</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 没有应用显示 -->
      <div class="no-app" v-if="noApp">
        <img src="@/assets/img/404.png" alt="">
        <div class="no-title">{{$t('error')}}</div>
      </div>
      <div v-else class='login-box-content new-content'
           :style="bgStyle">

        <div class="pa-0 content"  >
          <div class="login-wrap">
            <div class="login-box">
              <div class="login-content">
                <div
                  class=" align-center "

                >
                  <VBinding v-if="isType =='binding'" :bindingToken="bindingToken" @bindPwd="constraintPwd" @bindingFun="loginSuccess" @authMfaFunc="authMfaFunc" @authQrCode="authQrCode"></VBinding>
                  <EditPwd v-else-if="isType == 'editPwd'" :editToken="editToken" @editSubmit="editSubmit"></EditPwd>
                  <RetrievePwd v-else-if="isType == 'retrieve'" @goBack="goBack" @goEmail="isType='retrieveEmail'"></RetrievePwd>
                  <RetrieveEmail v-else-if="isType == 'retrieveEmail'" @goBack="goBack" @goPhone="isType='retrieve'"></RetrieveEmail>
                  <div :class="{'right-box':true,'auth-maf-content':isHiddenLoginInfo}" v-else>
                    <div class="login-title" 　v-if="!isHiddenLoginInfo">{{isType=='binding'?$t('login.binding.text'):'欢迎登录'}}</div>
                    <!-- 登录界面 -->
                    <div class="pwd-box" v-if="!isScanLogin">
                      <v-form
                        @submit.native.prevent
                        v-model="valid"
                        class="mb-6"
                        ref="ruleForm"
                        v-if="!isHiddenLoginInfo && !isAuthUserName">
                        <div class="form-item">
                          <i class="icon-wrap icon-user"></i>
                            <v-text-field
                              v-model="formData.username"
                              :rules="nameRules"
                              outlined
                              hide-details="auto"
                              @keydown="keydown"
                              required
                              class="rounded-lg input-h-md"
                              color="#5066e0"
                              :disabled="isLogin"
                              :placeholder="$t('login.usernamePlaceholder')"
                            ></v-text-field>
                        </div>
                        <!-- 密码登录 -->
                        <div class="fusb-Key pwd"    key="pwd">
                          <div class="form-item">
                            <i class="icon-wrap icon-password"></i>
                              <v-text-field
                                v-model="formData.password"
                                :rules="passwordRules"
                                outlined
                                color="#5066e0"
                                ref="pwd"
                                class="rounded-lg input-h-md"
                                :type="isPasswordVisible1 ? 'text' : 'password'"
                                :placeholder="$t('login.passwordPlaceholder')"
                                :append-icon="isPasswordVisible1 ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                                hide-details="auto"
                                @keydown="keydown"
                                @click:append="isPasswordVisible1 = !isPasswordVisible1"
                              ></v-text-field>
                              </div>
                        </div>
                      </v-form>
                      <v-form
                        @submit.native.prevent
                        v-model="valid"
                        class="mb-6"
                        ref="ruleOtpForm"
                        v-if="!isHiddenLoginInfo && !isAuthUserName">
                        <!-- otp登录 -->
                        <div class="fusb-Key"  key="otp">
                          <v-row no-gutters>
                            <v-col cols="8">
                              <div class="form-item">
                                <i class="icon-wrap  icon-code"></i>
                              <v-text-field
                                class="code-btn input-h-md"
                                ref="otp"
                                v-model="formOtpData.fUSBKeyData"
                                :rules="otpRules"
                                :title="$t('login.otpPlaceholder')"
                                :placeholder="$t('login.otpPlaceholder')"
                                @keydown="keydown"
                                outlined
                                color="#5066e0"
                                hide-details="auto">
                              </v-text-field>
                              </div>
                            </v-col>

                            <v-col class="code-text  ml-3 d-flex justify-end align-baseline" :class="otpText == $t('push.text') ? 'cursor-pointer':'text'" @click="pushFun">
                              <v-btn outlined v-if="otpText == $t('push.text')"  :disabled="disableButton" color="primary" min-height="50" style="width:100%">{{otpText}}</v-btn>
                              <v-btn outlined v-else style="width:100%" disabled min-height="50">{{otpText+'s'}}</v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </v-form>

                      <!-- 认证用户名成功界面 -->
                      <div v-if="isAuthUserName">
                        <!-- step 1. 列出当前用户要认证的策略　-->
                        <div class="more-title" v-if="authenticators.length > 0">
                          <img src="@/assets/img/text-left.png" alt="">
                          <span>{{$t('login.authenticationMethod')}}</span>
                          <img src="@/assets/img/text-right.png" alt="">
                        </div>
                        <div class="more-box" v-if="authenticators.length > 0" :style="{textAlign: authenticators.length < 6 ? 'center' : 'left'}">
                          <template v-for="(item, index) in authenticators" >
                            <v-tooltip
                              color="rgba(0, 0, 0, 0.75)"
                              top
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <div class="img_box">
                                  <img
                                    v-bind="attrs"
                                    v-on="on"
                                    class="img1_normal"
                                    @mouseover="imgLarge(item.logoBase64,index)"
                                    @mouseleave="imgSmall(item.logoBase64,index)"
                                    @click="rowFun(item,index)"
                                    :src="item.logoUrl?(require('@/assets/img/' + item.logoUrl)):('data:image/png;base64,'+item.logoBase64)"
                                    alt=""
                                    :key="index"
                                  />
                                  <img v-bind="attrs" v-on="on" src="@/assets/img/Slice140.png" class="img_shadow_none" :style="{'display':(item.code == selectedMfaIndex ? 'block' : 'none')}" />
                                </div>
                              </template>
                              <div>
                                <div class="ant-tooltip-content"><div class="ant-tooltip-arrow"></div><div role="tooltip" class="ant-tooltip-inner">  <span>{{item.name}}</span> </div></div>
                              </div>
                            </v-tooltip>
                          </template>
                        </div>
                      </div>
                      <!-- step 1.1 列出当前用户要认证的策略列表　-->
                      <!-- <div v-if="isAuthUserName && showFUSBKey"> -->
                      <div v-if="isAuthUserName">

                        <!-- ldap登录 -->
                        <div class="fusb-Key ldap" v-if="(showFUSBKey && showFUSBKey == 'ldap')  || (authenticators[0].key == 'ldap' && !showFUSBKey)" key="ldap">
                          <v-text-field
                            v-model="password"
                            outlined
                            color="#5066e0"
                            class="input-h-md"
                            ref="ldap"
                            :type="isPasswordVisible2 ? 'text' : 'password'"
                            :placeholder="$tc('login.ldapPlaceholder',1, {0:selectAuthInfo.name})"
                            :append-icon="isPasswordVisible2 ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                            hide-details="auto"
                            @keydown="keydown"
                            @click:append="isPasswordVisible2 = !isPasswordVisible2"
                          ></v-text-field>
                        </div>

                        <!-- 短信验证码登录 -->
                        <div class="fusb-Key phone-code" v-else-if="(showFUSBKey && showFUSBKey == 'phoneCode') || (authenticators[0].key == 'phoneCode' && !showFUSBKey)" key="phone-code">
                          <v-row no-gutters>
                            <v-col cols="8" class="col_padding" style="padding-right:15px;">
                              <v-text-field
                                v-model="phoneCode"
                                ref="phoneCode"
                                :title="$t('code.phoneCodePlaceholder')"
                                outlined
                                hide-details="auto"
                                required
                                min-height="46"
                                color="#5066e0"
                                class="code-btn input-h-md"
                                @keydown="keydown"
                                :placeholder="$t('code.phoneCodePlaceholder')"
                              ></v-text-field>
                            </v-col>
                            <!-- <v-spacer></v-spacer> -->
                            <v-col cols="4" md="4" lg="4" xl="4" sm="4" class="code-text  d-flex justify-end align-baseline" :class="codeText == $t('push.sendCode') ? 'cursor-pointer':'text'" @click="getPhoneCode">
                              <v-btn outlined v-if="codeText == $t('push.sendCode')" :disabled="disableButton" color="primary" style="width:100%" min-height="50" >{{codeText}}</v-btn>
                              <v-btn outlined v-else style="width:100%"  disabled min-height="50">{{codeText+'s'}}</v-btn>
                            </v-col>
                          </v-row>
                        </div>
                        <!--邮箱验证码登录 -->
                        <div class="fusb-Key phone-code" v-else-if="(showFUSBKey && showFUSBKey == 'email') || (authenticators[0].key == 'email' && !showFUSBKey)" key="email">
                          <v-row no-gutters>
                            <v-col cols="8" style="padding-right:15px;">
                              <v-text-field
                                v-model="emailCode"
                                ref="email"
                                :title="$t('code.emailCodePlaceholder')"
                                outlined
                                hide-details="auto"
                                required
                                min-height="46"
                                color="#5066e0"
                                class="code-btn input-h-md"
                                @keydown="keydown"
                                :placeholder="$t('code.emailCodePlaceholder')"
                              ></v-text-field>
                            </v-col>
                            <!-- <v-spacer></v-spacer> -->
                            <v-col cols="4" md="4" lg="4" xl="4" sm="4" class="code-text d-flex justify-end align-baseline" :class="emailText == $t('push.sendCode') ? 'cursor-pointer':'text'" @click="getEmailCode">
                              <v-btn outlined v-if="emailText == $t('push.sendCode')" :disabled="disableButton" color="primary" style="width:100%" min-height="50">{{emailText}}</v-btn>
                              <v-btn outlined v-else  disabled min-height="50" style="width:100%">{{emailText+'s'}}</v-btn>
                            </v-col>
                          </v-row>
                        </div>
                        <!--择UAF指纹/人脸认证登录 -->
                        <div class="fusb-Key fido-uaf fido-u2f" ref="fidoUaf" v-else-if="(showFUSBKey && showFUSBKey == 'fidoUaf')  || (authenticators[0].key == 'fidoUaf' && !showFUSBKey)" key="fidoUaf">
                          {{$t('login.fidoUaf')}}
                          <!-- <v-btn :disabled="(uafText == $t('push.text') ? false : true) || disableButton" v-if="uafText != $t('push.text')" class="key-btn" type="primary">{{uafText == $t('push.text') ? uafText : uafText+'s'}}</v-btn> -->
                        </div>
                        <!-- 临时认证口令 -->
                        <div class="fusb-Key" v-else-if="(showFUSBKey && showFUSBKey == 'tempLogin') || (authenticators[0].key == 'tempLogin' && !showFUSBKey)" key="tempLogin">
                          <v-text-field
                            ref="tempLogin"
                            v-model="tempLoginData"
                            :title="$t('login.tempLoginPlaceholder')"
                            :placeholder="$t('login.tempLoginPlaceholder')"
                            @keydown="keydown"
                            outlined
                            class="input-h-md"
                            hide-details="auto">
                          </v-text-field>
                          <!-- color="#5066e0" -->
                          <!-- class="more-input"  -->
                        </div>
                        <!--FIDO2认证登录 -->
                        <div class="fusb-Key fido-u2f" ref="fidoU2f" v-else-if="(showFUSBKey && showFUSBKey == 'fidoU2f') || (authenticators[0].key == 'fidoU2f' && !showFUSBKey)"  key="fidoU2f">
                          {{$t('login.fidoU2f')}}
                        </div>
                        <!--FastPass 认证登录 -->
                        <div class="fusb-Key fido-u2f" ref="fastLogin" v-else-if="(showFUSBKey && showFUSBKey == 'fastLogin')  || (authenticators[0].key == 'fastLogin' && !showFUSBKey)" key="fastLogin">
                          {{$t('login.fastLogin')}}
                        </div>

                      </div>
                      <div>
                        <v-btn class="login-btn sub-btn" type="primary"  :loading="loadingButton" v-if="showFUSBKey !='scanLogin' && showFUSBKey != 'fidoUaf'" :disabled="(showFUSBKey == 'fidoUaf' && uafText != $t('push.text')) || disableButton" @click="onSubmit">{{loginText}}</v-btn>
                        <v-btn class="login-btn sub-btn" type="primary"  :loading="loadingButton" v-else-if="showFUSBKey == 'fidoUaf'" :disabled="(showFUSBKey == 'fidoUaf' && uafText != $t('push.text')) || disableButton" @click="onSubmit">{{uafText == $t('push.text') ? loginText :  loginText + '('+ uafText + 's' + ')'}}</v-btn>
                        <div style="display: flex;justify-content: space-between;">
                          <div class="tip" >
                                                <span v-if="isAuthUserName && !isHiddenLoginInfo">
                                                    <v-icon size="22">{{ icons.mdiArrowLeft }}</v-icon>
                                                    <a href="javascript:void(0)" @click="refreshLogin">{{$t('login.backLogin')}}</a>
                                                </span>
                          </div>
                          <div class="tip">
                            <span  @click="retrieveFun" v-if="!isHiddenLoginInfo && showEditPwd">{{$t('login.forgetPwd')}}</span>
                            <span class="name-pwd" v-if="isLdap" @click="namePwdFun">{{$t('login.accountPwdLogin')}}</span>
                          </div>
                        </div>
                      </div>
                      <!--                                <div class="languages-box" @click="languagesChange" v-if="!isHiddenLoginInfo">-->
                      <!--                                  &lt;!&ndash; <a-icon type="global"/> &ndash;&gt;-->
                      <!--                                  <v-icon size="22">-->
                      <!--                                    {{ icons.mdiWeb }}-->
                      <!--                                  </v-icon>-->
                      <!--                                  <span>{{languages}}</span>-->
                      <!--                                </div>-->
                    </div>
                    <!-- 电子围栏扫码 -->
                    <div class="pwd-box" v-else>
                      <div class="code-box">
                        <img src="@/assets/img/Slice132.png" class="code-box_bg"/>
                        <div class="code" ref="qrCodeUrl"></div>
                        <p class="code-box_txt">{{$t('login.appLogin')}}</p>
                        <div class="stale-box" v-if="showFenceStale">
                          <img class="stale-img" src="@/assets/img/stale.png" alt="">
                          <div class="qr-text">{{qrFenceText}}</div>
                          <a src="javascript:;" v-if="isRefresh" @click="getCode('refresh')">{{$t('login.clickRefresh')}}</a>
                        </div>
                      </div>
                      <div class="tip" v-if="isAuthUserName && !isHiddenLoginInfo && isType != 'authToken' ">
                        <v-icon size="22">{{ icons.mdiArrowLeft }}</v-icon> <a href="javascript:void(0)" @click="refreshLogin">{{$t('login.backLogin')}}</a>
                      </div>
                    </div>

                  </div>
                </div>



              </div>
            </div>
          </div>

        </div>

        <VVerify v-if="isType != 'binding' && isType != 'authToken'" ref="verifyBox" :verification-object="verificationData"
                 @closeVerifyBox="closeVerifyBox"
                 @refreshFun="refreshVerify"
                 @successFun="multipleFuncAuth"
                 :captchaType="captchaType"></VVerify>
      </div>
      <!-- footer start -->
      <div class="footer-box">
        <div class="container d-flex align-center  justify-center" style="height: 200px">
           <div v-html="bottomContent"></div>
          <div class="position-absolute " style="right: 10px">
              <div class="d-flex">
                <div>
                  <img  src="@/assets/img/android.png" style="height: 180px;width: 180px">
                </div>

                <div style="margin-left: 10px">
                  <img  src="@/assets/img/ios.png" style="height: 180px;width: 180px">

                </div>

              </div>


          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    getImageNews,
    getNormalNews,
    reqLoginPwd,
    authLogin,
    ldapLogin,
    pushOtp,
    checkOtp,
    reGetQrcode,
    reqScanLogin,
    reqCheckFence,
    sendSms,
    phoneLogin,
    emailLogin,
    sendEmail,
    pushUaf,
    tempLogin,
    getLoginStatus,
    fido2AuthStart,
    fido2AuthConfirm,
    reqGetAuthenticators,
    reqFastLoginStart,
    reqFastLogin,
    reqRefreshLocationQrCode,
    reqGetCommonConfig,
    reqCrossBrowserLogin,
    reqGet
  } from "@/api/index";

  import VBinding from './binding'
  import RetrievePwd from './retrievePwd'
  import RetrieveEmail from './retrieveEmail'
  import VVerify from './verify'
  import ComputationNum from './computationNum'
  import EditPwd from './editPwd'

  import QRCode from 'qrcodejs2'
  import { base64urlEncode, base64urlDecode } from '@/utils/base64url-arraybuffer'
  import {IsIPMode,setCookie,getCookie,setPersistenceCookie,setUserExpriationTip,getStrAppkey} from '@/utils/cookie'
  import {platformType,snackbarMsg} from '@/utils/index'
  import {setNavigationInfo} from '@/utils/serverUrl'

  import VCarousels from './carousel'
  import FingerprintJS from '@fingerprintjs/fingerprintjs'

  import { mdiWeb, mdiArrowLeft, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
  import store from '@/store'
  import {removeWatermark} from "@/utils/watermark";
  import { IsPC } from '../../utils'
  import moment from 'moment'

  export default {
    components: {
      VBinding, RetrievePwd, VVerify, ComputationNum, RetrieveEmail, EditPwd, VCarousels
    },
    data() {
      return {
        moment,
        bottomContent:'',
        adList:[],
        EnterpriseList:[],
        technologyList:[],
        clientHeight:document.body.clientHeight,
        showAd:true,
        show:false,
        isLoading:true,
        formData: {},
        nameRules: [
          v => !!v || this.$t('login.usernameMsg')
        ],
        passwordRules:[
          v => !!v || this.$t('login.passwordPlaceholder')
        ],
        formOtpData:{},
        otpRules:[
          v => !!v || this.$t('login.otpPlaceholder')
        ],
        isLogin: false,
        allData: {
          authSourceList: []
        },
        // authToken自动登录成功，bindingToken绑定，editPwd修改密码，retrieve手机号重置密码，retrieveEmail邮箱重置密码，subVisible子账号
        isType: '',
        isLdap: false,
        bindingToken: "",
        restsObj: {},
        captchaType: '',
        visible: false,
        noApp: false,
        multiFactor: [],
        appKey:null,
        fUSBKeyData: '',
        showFUSBKey: null,
        companyLogoBase64:null,
        loginText: this.$t('login.loginText'),
        spinning: false,
        loadingButton:false,
        codeImg: null,
        codeTimer: null,
        password:null,
        phoneCode: '',
        codeText: this.$t('push.sendCode'),
        emailCode: '',
        emailText: this.$t('push.sendCode'),
        sourceName: '',
        tempLoginData: '',
        otpText: this.$t('push.text'),
        uafText: this.$t('push.text'),
        otpInterval: null,
        uafInterval: null,
        fastPassInterval:null,
        editToken: "",
        showStale: false,
        isRefresh:false,
        qrCodeSuccess: false,
        qrText: this.$t('login.qrText'),
        showEditPwd: true,
        isHiddenLoginInfo:false, //隐藏图片界面
        isOpenPicAuth:false,
        isAuthUserName:false,
        onceAuth:false,
        reqId:null,
        authenticators:[],
        fastLoginEnable:false,
        isScanLogin:false,
        selectAuthInfo:null,
        languages: null,
        qcodeUrl:null,
        verificationData:null,
        showFenceStale:false,
        qrFenceText:false,
        valid: false,
        thirdCode:[331,332,333,334,335,336,339,340,341,342], //第三方Code
        selectedMfaIndex:'',
        icons: {
          mdiWeb,
          mdiArrowLeft,
          mdiEyeOutline,
          mdiEyeOffOutline
        },
        //企业自定义登录界面样式
        diy:{
          bg:require('@/assets/images/images/body-bg.png'),
          opacity:0,
          type:1,
          bgColor:'#fffff',
          top:20,
          left:88,
        },
        isPasswordVisible1: false,
        isPasswordVisible2: false,
        abnormalCode:[1014 ,515 , 1003] ,// bug#0223339 这些code码,跳转至开始登录页面
        disableButton:false,
      };
    },
    computed:{

      bgStyle() {
        //if(this.diy.type == 1){
        // let opacity = this.diy.opacity>0?(this.diy.opacity/100):0
        return  {
          //'background-image': 'linear-gradient(rgba(0, 0, 0, '+opacity+'), rgba(0, 0, 0, '+opacity+')),  url("'+this.diy.bg+'")',
          // 'background-repeat': 'no-repeat',
          // 'background-origin':' border-box',
          // 'background-position': 'left center',
          // 'background-size':'cover',

          'background-image': ' url("'+this.diy.bg+'")',
          'background-position-x':'center',
          'background-position-y': 'top',
          'background-size': 'initial;',
          'background-repeat-x':' no-repeat',
          'background-repeat-y':' no-repeat',
          'background-attachment':' initial',
          'background-origin':' initial',
          'background-clip':' initial',
          'background-color':' rgb(231, 240, 251)',
          // }
        }

        // return {
        //   'background-color':this.diy.bgColor,
        // }
      },

      boxAbsolute(){

        let style = {
          "position": "absolute"
        }
        if(!this.diy.left && this.diy.left != 0) {
          this.diy.left = 88
        }
        let left = this.diy.left > 0?(100 - parseInt(this.diy.left))/100:1
        let b = `calc((100vw - 460px) * ${left}`
        style = {
          "position": "absolute",
          "top":this.diy.top + '%',

        }

        if(!IsPC()){
          style = {
            "position": "none",
            "margin-top": '0%',
            "margin-left":'auto',
            "margin-right":'auto',
          }
        }

        return style

      }

    },

    /*
    * 200　表示登录成功
    * 201　表示下步要验证多因素
    * 202 表示要更改密码
    * 203　表示扫码登录
    * 502 访问策略拒绝
    * */
    async created() {
      // 登录不需要黑暗模式
      this.$vuetify.theme.dark = false
      const res = await getImageNews()
      if(res.code == 200) {
        this.adList = res.data.imageContents
      } else {
        this.adList = []
      }
      let params = {
        limit:6,
        newsCategory:0
      }
      let param2 = {
        limit:6,
        newsCategory:1
      }
      const res2 = await getNormalNews(params)
      if(res2.code == 200) {
        this.EnterpriseList = res2.data
      } else {
        snackbarMsg('error',res2.message)
      }
      const res3 = await getNormalNews(param2)
      if(res3.code == 200) {
        this.technologyList = res3.data
      } else {
        snackbarMsg('error',res3.message)
      }
      // let userAgent = navigator.userAgent.toLowerCase();
      //let userAgent = window.innerWidth
      //获取 rsa公钥，环境，ip模式
      reqGetCommonConfig().then(res=>{
        if(res.code == 200) {
          localStorage.setItem('rsaKey', res.data.rsaPubKey)
          localStorage.setItem('environment', res.data.environment)
          localStorage.setItem('urlMode', res.data.urlMode)
          if(IsIPMode() && !this.$route.query.appKey) {
            this.$router.push({
              path: '/404'
            })
          }else{
            document.cookie = "appKey" + "="+ escape (getStrAppkey(decodeURIComponent(this.$route.query.appKey)))
          }
          //跨浏览器登录
          let locationHref = decodeURIComponent(window.location.href)
          if(locationHref.indexOf("crossBrowserToken") > -1){
            let crossBrowserToken = locationHref.match(/crossBrowserToken=(\S*)/)[1];
            this.$passwordEncryption(crossBrowserToken).then((res)=>{
              reqCrossBrowserLogin({token:res}).then(res=>{
                this.refreshLogin()
              })
            })
          }else{
            this.pageInit()
          }
        }else{
          snackbarMsg('error',res.message)
          return
        }
      })

    },
    async mounted() {
      this.clientHeight = document.body.clientHeight
      removeWatermark()
      window.onresize= () => {
        return (() => {
          window.clientHeight = document.body.clientHeight
          this.clientHeight = window.clientHeight
        })()
      }


    },
    methods: {

      pageInit(){
        this.languages = this.$cookieStore.getCookie('lang') == "en" ? "Chinese" : "英文"
        // 判断第三方是否登录成功 authToken=登录成功 bindToken=绑定
        if (window.location.href.indexOf("bindToken") > -1) {
          this.isType = 'binding'
          this.isLoading = false
          this.bindingToken = window.location.href.match(/bindToken=(\S*)/)[1]
          setNavigationInfo({})
          this.companyLogoBase64Func()
          let loginSty = localStorage.getItem('loginStyle')
          let style = JSON.parse(loginSty);
          this.setLoginStyle(style)
        } else if (window.location.href.indexOf("authToken") > -1) {
          this.isType = 'authToken'
          this.goLogin()
        } else if (window.location.href.indexOf("errMsg") > -1) {
          let message = decodeURIComponent(window.location.href).match(/errMsg=(\S*)/)[1]
          snackbarMsg('error',message)
          this.loginStatusFun()
        } else {
          this.isType = ''
          this.loginStatusFun()
        }
      },
      //获取当前访问状态
      loginStatusFun() {
        //如果是ip地址格式
        const fpPromise = FingerprintJS.load({
            monitoring: false
          })
        ;(async () => {
          // Get the visitor identifier when you need it.
          const fp = await fpPromise
          const result = await fp.get()
          let params = {
            platform: platformType(),
            fingerprint: result.visitorId
          }
          getLoginStatus(params).then(res => {
            // 200，代表已登录，会返回"用户信息、token"等，跳转首页，或者跳转到页面路径上的redirectUrl
            // 201，代表已登录，还需要验证多因素，会返回"多因素列表、appkey和企业logo"。验证多因素和之前那些接口一样处理
            // 302，代表已登录，需要选择子账号后跳转应用，会返回"appkey，子账号列表"
            // 401，代表未登录，会返回 原来getLoginApp的结果："appkey、企业logo、loginMode等"
            // 404，代表应用不存在

            //  res = {"code":201,"message":null,"data":{"userInfo":{"username":"jinbiao"},"authenticators":[{"type":"","code":301,"key":"pwd","name":"密码","logoBase64":"iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARLSURBVHgB7ZrbbxtFFMa/mV3fElwMtI4CgYbQFFpKFJpQgbjUCUJCAilFPFdNuPwBPPS1VgDxDBJPQJWU8MADiNDCAw8loYjSiqK6aYUEAdWES6r0EsdJfN8ZZtaNCYkBezLbZlf9SZZ3xrtrf3Nmzjl7PARVeCl+McbB93GOmGi2Yv2RAEGCWPzTg683ja78kCxv9MenWw2YQ5zzGNxDkhGrZ3iwObnUURHVH5/ppJyMATwC95FipCCEtSRkwxYlLUS5edqlgpYQwqwHpcWobFFuuNVCy4kQZgzJA/Ji/NIeztkn8AjMsnooB+uDh6CmsY+Ck054CRGGxJri3hIl4iqFBzHhIKZJEL2F4o4mE6ZBkM0xpBcZzv9hQQR4OIUjogxK8HhXAE90hbC5efVX/HahhGOncvjyuyycgLxwYEbrkG2MGHj5+TC23OX733Mnp4p456M0rswx6ESrpUJBiv0DESGsvFTnFhiOfZ9D4sc8MlmGcAPFfW0B9O4KIhKmaBfC9/dH8MZ7s5hf1De2Wi31yt6bsWOL3z4+eTaPkSPzyOZX3z7cSPBcbyN2d4fs9sRkHm99kIYutHm/B9r9FUFnJwv2tKomSCKt8v6RBXFe3m53tAew/R4/dKFNVM+u8qgvZBhGPpuv6ZpDhxeQyZWFx7qD0IUWUdJdt0TLy3Py1yIup2pb+LNphh9+KdjH7Zt9CAUIdKBFVPRWituuOofzf5bquRS/z5TP39BIEb5Jz8TRchfD+HuEZ9MW6mF2mTv3m+vIUmtheWJB9Gi6/qKcYE1x6qlHQujaHsCdIrcLXl3khSJHyar9ltLJ+H3lazMiN5y5YuF4Io+jJ9VTKOWMYu+zYcQeWu2G5Q9c+pH10iAyktbb5cuHthYT735cW2hYidL069jqrypIJw93BLFzWwAqKInqvFdf9P8vtrWpTSQlURvqjCf5AseFyxaKpfqWbyRsQAVHHxKZ8NejRzP44tssSkKQIcbimd2N6Is1wEkcdemnzuXx+dcZW5DEEnH28NgiTkzk4SSOijoxkavefyYHJ3FUFOfVXTtVWyo146ioHVure0kZsJ3EUVFPimesx3b+M571ir7u+10sSvL0o6FV7YBPU+b6L3gyob0hyi04mlFImjeaODi4CdcSJUsV6ytDKMMUC7dKoqamr42qqekiVFAS9c3pXKVe5xQpUT47fkYtR1QSJf+OeXMkZT96O4G879sfztl1QRXWVKOQQVQWIcOiZkc1xVM5YD+Jgqh8BlNlTd4vL4os534uYL3h2eCbhIcQkzZBQTAOD0G4EMVADsFDcEJHbZ81EL84Rty1Ha4qHDw59GrT3bTcKA2ItxRcjFhLKU5Yjzy2RcntZIxAdrhSWFkQKhsZKy59eDCakPvlpAnhIkRpcZzb+/yiiaW+qnnAwIFLfYSzPUJ9pzhh3e1dEpZJiv+yxjkjw0Ovbfpq5ed/AVCNexVlHscCAAAAAElFTkSuQmCC","descp":"通过密码登录"},{"type":"","code":311,"key":"phoneCode","name":"短信验证码","logoBase64":"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","descp":"通过短信形式接收的验证码快速登录"},{"type":"","code":312,"key":"email","name":"电子邮箱验证","logoBase64":"iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAAAXNSR0IArs4c6QAAA0pJREFUaEPt2k1IVFEUB/D/uTOTE5kLFyUoWRFBi+zLMoygpYuiNkpihjMSRW5qK9iiwm1tgqJSyWrENpVBLSNIsuxLF0FEpVhoiyAZaHScd+LOODbazHjfvHkf8+gth/txfu/eeXPmvkPIcLX2cynmtKOaoDowbwNQRsCKTO3N/pyBWQCTAI8Ipsfwir6bDfQz3by09MOWbvYLv9YO4CyAYrODNTB+GMAlLSI6ewIUSR1nEar5Fm/w+bT7AKoMTGZxVxqJRulI73H6kpx4ARW8E9nIwveMgHKLo8rHdN+hRfd3Nfk/y8HiqMSW4yGAC2iFFt8LZozyjNgjt2IcFQzFzgPoyMcts3mMC12NnnNUf+NX6epVxWMOfyio3qsweUQltd6NnWbCFdVeTm9HjDYK9GkPifmQ04NVjY+JBiRqjJjXqXZyejsmGqdgXywCRpHTg1WOjzBDwVCMlTsUSMP/qAJZKOheqbIS4NgugvgnFTaHrDFw+zVjclp9fF2oLWuBjz+AmkpCoMZ8mAR1DzGGxhib1wAfptRgulDN1YQSP3D1OZsOSwWd2keYjgC9w2rPNN2oA5sIbybYVNhS0M4KwtNPbC5KbgKzYOlAcj5LUGbAMoEsReUTlg1kOSofsOVAtqCMwFRAtqFygamCbEXpgekB2Y5SgekFOQKVDZYLyHEo+W+tdn0iV5SXzOUGvzI8BMj0R2YLKpdlP76ZgknNNraXA9cGGdXzBwbD48DJWsK7b4gnqqowW1Hp0qe3E4zrLxLJ6Im9hB0VBL3b0DZUtnxwLpZYV6/n7/rqgdmCyjXBVYVZjsoVlFwzFZilKKMgVZhlqHyBVGCWoPINWg5mOsosUDaYqSjXHby48ohMbg95mNmym+ARKhmb8TYxDeh5ZeJhpvEQrRlB17mfNSEZn8Wd76dc+SYxEJobINBB44vujBEY/Mh9b+dJtJGsFuOY5q46Crlp3FLxwhoudjd5OhZqk6hIe0mErc74ZuiPQtYmhb2i5l4D/XZvFVnyvsTr/bzaAxTSihFGo7PicNp6vySsvp9XFke1dhI44/AirDBruBz2iU655VI3bMaTxPmnYiOD60CiCsxOqKGdIvB7gJ6QR4Qy1dD+AeXJ9k0Mf+LGAAAAAElFTkSuQmCC","descp":"通过邮件形式接收的验证码快速登录"},{"type":"","code":302,"key":"scanLogin","name":"飞天云信令扫码登录","logoBase64":"iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMpSURBVHgB7ZpLSFRRGMd/56KmSQ9NExNB7eVjkUbUokUOUYtaKDWBbQoXurJN1KpFuemxCoQicGHuBJGMiFahUYS1ccCywTKHMIKIsERJHT2dM9PI6Izgud2pucP8YJh7vzPDPf/7nfu/5yWIQ6VX1iM5j4X+LiPJkOATEt8SPBzrE/2ry0X0SWWTLCNIlzqsxy1IAizi8feLQCS0LKr6jKyVkgF1F7biMlSdp5YEnve9wqfPQ6J0hkSQYTcKiqCFKQ11OmNWKLLozgxFI3T9M0KPDqLqtGyUggekDh5LWjSQSijXtpQ11pJa1FvqWUotUYIyixQkLcotZGCD7flQVhwbDy7CyAdYCGJMzU7IzY6Nj31Sb9VpjDAWtSETuq/FF6VpvQ7PhzHi2CHouBS/7N0EnL0CcwusG2NRWVmwbQv41cVej64sm/0FE58xZmgELt4O37BoThyGfXvUNTMTLCrCq7dwsxtHmJ6FJy9j41XlYVGmpI1iLc6dhB2FOMK8amb3+sJN2S6OiAq1/d04ws8Z6PzL7rVx85ufh8mvMG7DEEyZUdn6/iOcPROMM6Vd6NRl/gkdPdD1yMz5NElvFNMzGJPu+7mF9HtqPQy9gS/fjP5C3mY1XN2PYzgq6qOy+eZ2bHGjDRqP4AiONr+ifHs9i+ICqNuLYziaqdwceHqX/07a/dxCWpRbsCXqQBWUFpFwdpVCeQnGGIvS8wi3LqihfBsJp70VWhoxxliUnnjZlAs5G0g4G7OxhSPvKT2NNTePI+hJGNNB4WocEdXeSVKR7qVHU5gHV1tWxnQTvNMbbkIm1FSA92hsvMDmgq2xqBlV4ccvoKIk/IlGT2tlZWLMwRpoOh6/bHwSY0SlV0qSgEx1ey0RG5+zYRqODxLtYmelZC3S3SS3YKmF3wAphHosfTpTg6QQyvaUKIlDq0zJgXLQ/vCGK68cwE3b4dZCEvD3ifKwUWTQrNRN4WJC9V/Eo49Dovw9IiAEHrcK0/XW9Y9sZFy29NFe4ZMZ1LnQDQdlkLrRPxsYNSLer6q9smFJ0Kg3YyXl3iV945eUa1vc9/eKZ6uLfwMzg9gciC07YAAAAABJRU5ErkJggg==","descp":"通过飞天云信令APP扫描二维码快速登录"},{"type":"","code":313,"key":"otp","name":"OTP动态口令","logoBase64":"iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPgSURBVHgB7ZpPSFRBHMe/89zU1MCloEuKKeTNP7f05GKCCaZd6pBgkWLh0SC6dKlLBzsrEhnowS5phkluaBc9+rJTQrJQhwxFkfXvrm+a36zzfE9X921q+B77AdmZN29m3vf3+81vZt3HEIelltoqjaGZA1WiWoBTB9cZmG4YxpD/1afBva3MWll6UFvAtvEaMTHugCHENQT8XaOh3Us7LLXWlTHwcWGFXLgOvsxhBPw9YzrVpKiYh9i0OwUphLA0Vk4e06jKDLjUQ1ZYLovKpQO2dP96I9P4O3gEzhHQNI03wENQ1tY4WBk8BG1DYk1xT4kSFGjwIClRbiElyi2kRLmFlCi34ElRPvwDvuIS+Mqu4kxZJbTzF+U1Y3FefvK1MPj66m55bfXAcbQLsb5qDGt5++cP8TeHyFQQ0e8zSAa23FrLHd+clY3M+iakVzfif7I1OYbN4X7TcIlw7CkSlN3xAml5RfsmPAkoGpTX0itr4LtSgvDz9kM9b/aFQzJvtdkE0eAbb7uF1xr2CT0qxsI8IpNBQBgyYycqKFSzHj7FaufjhP0dJQp6aLKWlfXezn1CjwsSkFF/R65JK3ItC48l7A8HkDesbAYHkXm7TYbkSaLGp4Shwu5M5bWE/Zx5Kt/uDb4etmUsK+sDXcKLL2V55UkzIvokItOTsmy2D3Sb7du/5uKOQxnPV1wqQzH8rB0bw33yOnnreERdKrR3OkAQQencTO+Lf6SF6RqVVTtUypft4bjjRGdn5Lz0SRg74g+b23w+nFIo9MggSkQyoe4o+5HlrRY6bL/IqL4J+e8PQfYjsQVcKpLeoLJqZ2ezbe3xSK+okaFLCYr2RrWWaH0lwpGnIvqUrU4ZSKbcOKTlFZoZke4jC1M2U1mL2tVJQrXHg2XlyLVLUCZURo3OfkUiHInaCtp/WKDFaogJnVjtKOzdaKm+FRxK2M9x+G1+HjQ3QoLKdHRRC/o4oYen7JeWbx93432fo6NSUme/rLsd+/aJWHYL47hhZ3NsoUmCNj/0O+qb1Cl9TZwiMhZ+I/NG0+7kYuKT3IRpn6J5t2e/Oe6TlKcUtGjlkaW0YkdUjvk1Q3mNPtWasIYMPSTdbzWENW2Th1QfCsFkxBxJ1Gkn9XXeLaREuYWUKLeQEuUWPCsqBC/Bua4xYAIegjGmawbHG3gIxvmgfOFKHGrH4abX4Q4mlNszelkmCh7BPTqww81wtix0BKgoRfl7R0McLOBaYSQoygKkg6pmSvf3jOg8wsvhtmzIMcGjvNzfO6KrSyzefSstdQ2cGY2xl7FO5btLIcraGljvuZ6PX/Y2/gXkwJyhPy24dQAAAABJRU5ErkJggg==","descp":"通过从飞天云信令APP或OTP硬件令牌获取一次性动态口令登录，或经飞天云信令推送认证快速登录"},{"type":"","code":314,"key":"fidoUaf","name":"飞天云信令(FIDO)","logoBase64":"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","descp":"通过在飞天云信令APP校验指纹或人脸信息后安全登录"},{"type":"ldap","code":337,"key":"182a9c55b20818139989","name":"111","logoBase64":"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","descp":null},{"type":"","code":304,"key":"fastLogin","name":"飞天云信令FastLogin","logoBase64":"iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAAAXNSR0IArs4c6QAABXhJREFUaEPdmnls1EUUxz/TlqMcDVdDy2lJuUXAhFLBUgKU1ggBJSriHwgBEUGkHn9IAp4hGoMQL0whbWKCqIEgYtpSjigCUtKYlCpHAQuKlcrZlgAF2p95++uy23a3Ozvbbbd9f+6+N+/7nXkz8978nsKLWJvpQThzsUgDRgMxQHtv+s3w+x3gInAMRQ7VfKMWcdWTX1X/RyuLjsAqakhH0aUZwJq5sLgBrCeMtWoBt90HqUPK2kQcYXyP4iEzTy1gpTjGPWarxZQ4vd8nZWUyCDgA9G0BaIG6LAWS1EL+lIEcpGpDLh+rFa1Qw2koQpEgoegk9S4WqwOdrha3V7ynFrBGOU45xfmQPhR0Z0sOD4uBysriJSw+17ULeT3FMmVl8gMwM+TB6gPcJaTOAwP0bUJe8y8hJRdXh5CHqg+wSkhZ+vqGmiPTYcxbcnlA4Vr4fR1QYziYb7PgkoqMhcTP4IEn6yIpOwiHXoDyE74RGmgEh1SXgTBsGQxbCu28pI81d6E4E4o+hBv3MxwDCg1Nmo5Up77QfwYMmge9k0A1yJU9A7Zq4OLPcCEHyn6BK79BjSTk5mJOqufDMHAORA2GnmMhKt4chbtldRVcPw5XC6E4A/771e9xzUhFDYHZhRAuVUoQpfo27BgJlY48VVvMSA1ZBBM3aTsJSPHAfDj7lV9DmJEa+iJM2OiXI2Plw0vh1Jd+mZuRGv4yJH7ilyOfyrKXJMy6DXNWRLZJ/itw3D9fZqRGrITx633i1Fa4dRF2p8K1Y/Dg6zDuI5dpfjoc36A9lCi2PKkb5yA3BSrP2MD7psH0HBeJIyvgxKetiFT5SZvQzQs26K7xkJoHXeNcJJpvTy2HxHqzV3EaSvdD3NPQobvvmZVLNi8Nbl+ydbuPgul50Ele4tzk4EI4neV7PDcNs/AbugQmuJ1IlgXf9YObpdBjNKTthw49vAOR3G/PDLhbbutEJ0JKtufJ+GkulHzbDKTin4ekerO3fTBU1O6LXuMgdS+0j2oI5p9c2DcHqm/a/8VOg6k7vOeIe2fB31LH6ovZSkl+l7ylrpfyYshJBjnJRHo/Cim50K6zS69kGxx4zpXbDXgCJm+F8EbKuexkKJOXO30xIxU7BdL2NfQiOVvOZNc+6TMVpu6CiEg4nQmHFoMksCLx82HiZgiLaBzt19FQdVmfkfGR3r47zLviOROXRDR3ClTVPnP3exxiJkPBGy5gI1ZAwnpQYY2DrSyBbfLG6p+YrZT4mJEP0QmevV0ugN3T4E7tQeCuNWYNjH1HD+WpDDi8RE/XTcuc1PBldlXrTaRkyEuFu5W1GgoS1oGU9rqSOw3+9RDmPuzNSUV0gqfOQcdo7y6k+JOjW0qIiRkweIEuHag4C9uHGL1lmJMSePXvK0+Q5XKVZLVzP31CoilhJ+FnIIGRIgwe2w8xyQauGzG59gfsHAPWPaNxAySFvQIzCyCytxGABkY19yB7Elzyv4x3jhU4KRkp+hFI3VP3ojWlWPAmFH1gau2waxpSMlKfFDvdiXDLIPyFVrzJfg8MUJqOlHPFhJhJKJ7cCEeWuzKOAIg1LSkB0rk/TNoCMUl6sOS4P/oanPxCT19Dq+lJOYI6DIYuhbFvQ8de3mFcyAYp1yuKNaDqqwSHlNN/RBf7wo17BuTxU5JXuVRL98KZLPs1NggSXFJBAKwzZJv9PtUmvyTukkJCZ1lbic6PbfTrfFvso5CQsrJoGx0v8L5ayGpXb5LFUWBUK9k3nmAWcZ3x6lVutd0uMidtR79fODtb2YoVUc0sj/1+94l9TCTdWIXFypBuwpLmKsUGrrNWQs49Hr1+Qq/tLnsW5eihlU7NUOihLQMKscjFYqu3Htr/AeAD1lj6m/RpAAAAAElFTkSuQmCC","descp":"通过飞天云信令FastLogin快速登录"},{"type":"","code":315,"key":"fidoU2f","name":"FIDO2认证","logoBase64":"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","descp":"通过FIDO2硬件令牌或FIDO2(WebAuthn)身份验证器快速认证登录"}],"reqId":"9E3qYVDkvUgFmqet"}}
            if (res.data) {
              setNavigationInfo(res.data)
              this.setLoginStyle(res.data.loginStyle)
            }
            if (res.code == this.$GLOBA.StatusOK) {

              this.setCookieZeroTrust(res.data.zeroTrust)

              if (window.location.href.indexOf("redirectUrl") > -1) {
                this.urlFilter()
              } else {
                this.cookieAllFun(res.data, this.$GLOBA.StatusOK)
                if(IsIPMode()){
                  this.$router.push("/adhibition?appKey="+this.$route.query.appKey)
                }else{
                  this.$router.push("/adhibition")
                }
              }

            } else if (res.code == this.$GLOBA.StatusLoginOK) {
              this.isLoading = false

              this.cookieAllFun(res.data, this.$GLOBA.StatusLoginOK)
              res.data.loginMode = []
              this.allData = res.data
              //   this.multiFactor = res.data.authenticators
              sessionStorage.setItem('reqId', res.data.reqId)
              this.appKey = res.data.appKey
              this.isHiddenLoginInfo = !res.data.isLogin


              this.showEditPwd = res.data.userEditPwd // 隐藏忘记密码
              this.isLogin = true // 输入框禁选，多因素开启
              //    this.isType = "authMfa"
              if(res.data.userInfo){
                this.formData.username = res.data.userInfo.username
                sessionStorage.setItem('username',res.data.userInfo.username)
              }

              this.authMfaFunc(res.data.authenticators)
              this.isScanLogin = false

            } else if (res.code == 203) {
              this.isLoading = false
              this.isHiddenLoginInfo = !res.data.isLogin
              //203 扫码登录
              //只有登录过后才有的扫码登录
              //让用户走checkMfa接口
              this.appKey = res.data.appKey
              // this.multiFactor = []
              // this.isAuthUserName = true
              // this.isType = "authMfa"
              // this.qcodeUrl = res.data.qrCode
              sessionStorage.setItem('reqId', res.data.reqId)
              //this.newScanCode(res.data.qrCode)
              if (res.data.companyLogoBase64) {
                sessionStorage.setItem("companyLogoBase64", res.data.companyLogoBase64)
                this.companyLogoBase64 = res.data.companyLogoBase64
              }


              this.newScanCode(res.data.qrCode)
            } else if (res.code == this.$GLOBA.StatusFound) {
              this.allData = res.data
              this.cookieAllFun(res.data, this.$GLOBA.StatusFound)
              this.subForm(res.data)
            } else if (res.code == this.$GLOBA.StatusUnauthorized) {
              this.isLoading = false
              this.allData = res.data
              this.bottomContent = res.data.htmlContent
              if (res.data.fastLoginEnable == true) {
                this.fastLoginEnable = true
              }

              this.cookieAllFun(res.data, this.$GLOBA.StatusUnauthorized)
              this.showEditPwd = res.data.userEditPwd
            } else if (res.code == this.$GLOBA.StatusScanningOK) {
              this.isLoading = false
              this.noApp = true
            }else if(res.code == 404){
              this.$router.push({
                path: '/404'
              })
            }else {
              this.isLoading = false
              if (res.data && res.data.companyLogoBase64) {
                sessionStorage.setItem("companyLogoBase64", res.data.companyLogoBase64)
                this.companyLogoBase64 = res.data.companyLogoBase64
              }
              if (res.data.fastLoginEnable == true) {
                this.fastLoginEnable = true
              }
              //501 权限限制
              //502 策略受限制
              if(res.code == 501){
                window.location.replace('/#/501')
              }else if(res.code == 502){
                window.location.replace('/#/error?errCode='+res.code)
              }else{
                if(res.data.userInfo) {
                  this.formData.username = res.data.userInfo.username
                }
                snackbarMsg('error',res.message)
              }



            }
            // 动态修改ico（备用）
            // this.$nextTick(()=>{
            //     var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
            //     link.rel = 'icon'
            //     link.href = 'data:image/png;base64,'+ res.data.companyLogoBase64
            //     document.getElementsByTagName('head')[0].appendChild(link);
            // })
          })
        })()

      },
      //网站logo
      companyLogoBase64Func() {
        if (sessionStorage.getItem('companyLogoBase64')) {
          this.companyLogoBase64 = sessionStorage.getItem('companyLogoBase64')
        }
      },

      //设置网站登录页面样式
      setLoginStyle(data){
        if(localStorage.getItem("loginStyle")){
          localStorage.removeItem("loginStyle")
        }
        if(data){
          localStorage.setItem('loginStyle',JSON.stringify(data))
          let style = Object.assign({},this.diy)
          style.top = data.top
          style.left = data.left
          style.type = data.type
          if(data.type == 1){
            style.opacity = data.opacity?data.opacity:1
            if(data.coverImgBase64) {
              style.bg = "data:image/jpeg;base64,"+data.coverImgBase64
            }else{
              style.bg  = require('@/assets/img/bg'+data.defaultCoverImg+'.png')
            }

          }else{
            style.bgColor = data.color
          }
          this.diy = style
        }
      },

      //快快速登录　
      quickLogin() {
        this.spinning = true
        const fpPromise = FingerprintJS.load({
            monitoring: false
          })
        ;(async () => {
          // Get the visitor identifier when you need it.
          const fp = await fpPromise
          const result = await fp.get()
          let params = {
            platform: platformType(),
            fingerprint: result.visitorId
          }
          reqFastLoginStart(params).then(res => {
            if (res.code == 200) {
              sessionStorage.setItem('reqId', res.data.reqId)
              //換起應用
              this.callApp(res.data)
            } else {
              this.spinning = false
              snackbarMsg('error',res.message)
            }
          })
        })()
      },
      callApp(data) {
        let encodeBase64URL = Buffer.from(JSON.stringify(data), 'utf-8').toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/gi, '')
        window.location.href = "ft://" + encodeBase64URL
        setTimeout(() => {
          this.fastLogin()
          this.spinning = false
        }, 1000)
        //定时调度
      },
      // 设置缓存
      cookieAllFun(val, code) {
        if (val.companyLogoBase64) {
          sessionStorage.setItem("companyLogoBase64", val.companyLogoBase64)
          this.companyLogoBase64 = val.companyLogoBase64
        }
        if (code == this.$GLOBA.StatusOK) {
          setPersistenceCookie('userInfo', val.userInfo)
          setPersistenceCookie('noticePullInterval', val.noticePullInterval)
        }
        setPersistenceCookie('userEditPwd', JSON.stringify(val.userEditPwd))
        //setPersistenceCookie('rsaKey', val.rsaPubKey)
        if(val.rsaPubKey){
          localStorage.setItem('rsaKey', val.rsaPubKey)
        }
      },
      //清空所有的定时嚣
      clearAllSetTimeOut(){
        clearTimeout(this.otpInterval)
        clearTimeout(this.uafInterval)
        clearTimeout(this.fastPassInterval)
        clearTimeout(this.codeTimer)
      },

      //authToken 登录
      goLogin() {
        let params = {
          authToken: window.location.href.match(/authToken=(\S*)/)[1],
          reqId:sessionStorage.getItem('reqId')
        }
        authLogin(params).then(res=> {
          if (res.code == this.$GLOBA.StatusOK) {
            this.loginSuccess(1, res)
          }else if(res.code == 201) {
            this.authMfaFunc(res.data.authenticators)
            this.isScanLogin = false
            this.isLoading = false
          }else if(res.code == 203){
            //203 扫码登录
            this.isLoading = false
            this.newScanCode(res.data.qrCode)
          }else if(res.code == 302){
            this.subForm(res.data)
          }else{
            this.isLoading = false
            snackbarMsg('error',res.message)
            this.loginStatusFun()
            setTimeout(()=>{
              this.refreshLogin();
            },500)

          }
        })
      },
      //点击登录按钮操作
      async  onSubmit() {
        this.loadingButton = true
        let self = this
        //如果没有认证用户
        if(!this.isAuthUserName) {
          if (this.$refs.ruleForm.validate() && this.$refs.ruleOtpForm.validate()) {
            let password = await this.$passwordEncryption(this.formData.password)
            checkOtp({
              username:this.formData.username,
              password:password,
              otp:this.formOtpData.fUSBKeyData,
            }).then(res=>{
              this.loadingButton = false
              if (res.code == 200) {
                this.loginSuccess(2, res)

              }else if (res.code == 201){
                this.authMfaFunc(res.data.authenticators)
                this.isScanLogin = false

              }else if(res.code == 203){
                this.newScanCode(res.data.qrCode)

              } else if (res.code == 202) {
                // 新用户强制修改密码
                this.$cookieStore.setCookie('username', this.formData.username);
                this.constraintPwd(res.data.updatePwdToken)

              } else if (res.code == this.$GLOBA.StatusFound) {
                this.allData = res.data
                this.subForm(res.data)
              }else if(res.code == 2034){
                this.refreshVerify()
                snackbarMsg('error',res.message)
              } else {
                snackbarMsg('error',res.message)
                this.actionAbnormalErrorCode(res.code)
              }

            })

          }else{
            self.loadingButton = false
          }
        }else {
          // if(!sessionStorage.getItem('reqId')){
          //     snackbarMsg('error',this.$t('login.loginOutTime'))
          //     setTimeout(()=>{
          //         this.refreshLogin();
          //     },500)
          //     return
          // }
          if(this.showFUSBKey == "fidoUaf" && this.uafText == this.$t('push.text')){
            this.pushFidoUaf()
          }else if (this.showFUSBKey == "fidoU2f") {
            if (window.PublicKeyCredential === undefined ||
              typeof window.PublicKeyCredential !== "function") {
              var errorMessage = this.$t('login.notSupportWeb')
              if (window.location.protocol === "http:"){
                errorMessage = this.$t('login.supportSecurity')
              }
              snackbarMsg('error',errorMessage)
              this.loadingButton = false
              return;
            }
            try{
              this.fiao2Auth()
            }catch (e) {
              this.loadingButton = false
            }
          }else if (this.showFUSBKey == "fastLogin"){
            this.fastLoginStart()
          }else if (this.showFUSBKey == "scanLogin"){

          }else {
            this.clearAllSetTimeOut()
            if(this.showFUSBKey == 'pwd') {
              //验证码
              this.refreshVerify()
            }else{
              this.multipleFuncAuth()
            }
          }
        }
      },
      //这里走其它方式认证（微信，飞书等）
      restsFun(val) {
        this.restsObj = val
        // needPwd=true LDAP登录
        if (val.needPwd) {
          this.sourceName = val.sourceName
          this.isLdap = true
          this.isLogin = false
        } else {

          this.$serverUrlFun().then(serverUrl=> {
            var url = serverUrl + '/authSrc/authorize/';
            var formStr = '<form style="visibility:hidden;" method="POST" action="' + url + '">' +
              '<input type="hidden" name="sourceKey" value="' + val.key + '" />' +
              '<input type="hidden" name="appKey" value="' + this.$route.query.appKey + '" />' +
              '<input type="hidden" name="reqId" value="' + sessionStorage.getItem('reqId') + '" />'+
              '<input type="hidden" name="callback" value="' + window.location.href + '" />'+
              '</form>';
            var win = window.open("", "_self",);
            win.document.body.innerHTML = formStr;
            win.document.forms[0].submit();
          })
        }
      },
      retrieveFun() {
        this.isType = "retrieve"
      },
      goBack() {
        this.refreshLogin()
      },
      namePwdFun() {
        this.showFUSBKey = null
        this.isLdap = false
        this.isType = ""
      },


      keydown(e) {
        if(e.key == "Enter") {
          this.onSubmit()
        }
      },
      imgLarge(src,index){
        let phoneFlag = /(android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini)/i.test(navigator.userAgent)
        if(!phoneFlag){
          let imgFocus = document.getElementsByClassName("img1_normal")[index]
          imgFocus.style.height = "40px"
        }
      },
      imgSmall(src,index){
        let imgFocus = document.getElementsByClassName("img1_normal")[index]
        imgFocus.style.height = "36px"
      },
      //选择认证方式
      rowFun(val,index) {
        if(this.showFUSBKey == "scanLogin" && val.key == 'scanLogin'){
          return
        }
        this.selectAuthInfo = val
        //只要切换认证源就清除定时嚣
        this.clearAllSetTimeOut()
        if(val.type == 'authSrc') {
          this.restsFun(val)
        }else{
          this.selectedMfaIndex = val.code

          this.restsObj = val
          if(val.code == 337 || val.code == 338){
            this.showFUSBKey = val.type
          }else{
            this.showFUSBKey = val.key
          }
          switch (val.key) {
            case "fidoUaf":
              this.uafText = this.$t('login.push')
              break
            case "otp":
              this.otpText = this.$t('login.push')
              break
            case "scanLogin":
              this.getScanLoginQrcode()
              break
          }
          this.$nextTick(()=>{
            if(val.code == 337 || val.code == 338){
              this.$refs[val.type].focus()
            }else{
              if(!["fidoUaf",'fidoU2f',"otp",'scanLogin'].includes(val.key)){
                this.$refs[val.key].focus()
              }
            }

          })
        }

      },

      //otp认证
      async pushFun() {
        if (this.otpText == this.$t('push.text')) {
          if(!this.$refs.ruleForm.validate()){
            return
          }

          let pwd = await this.$passwordEncryption(this.formData.password)
          let params = {
            username:this.formData.username,
            password:pwd,
            // reqId: sessionStorage.getItem('reqId'),
          }
          let num = 0
          let pushOtpFunc = (params) => {
            pushOtp(params).then(res => {
              if(!params.otpReqId){
                params.otpReqId= res.data
              }
              if (res.code == this.$GLOBA.StatusScanningOK) {
                if(num < 1) {
                  let userAgent = navigator.userAgent.toLowerCase();
                  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|xiaomi/.test(userAgent)) {
                    window.location.href = "ftiam://com.ft.iam";
                  }
                  num ++
                }
                this.otpInterval = setTimeout(() => {
                  pushOtpFunc(params)
                }, 1000)
                this.scanResult(res, this.otpInterval, 4)
                this.otpText--
                if (this.otpText <= 0) {
                  clearTimeout(this.otpInterval)
                  this.otpText = this.$t('push.text')
                }

              } else {
                this.scanResult(res, this.otpInterval, 4)
              }
            })
          }
          this.otpText = 60


          pushOtpFunc(params)
        }
      },




      generateQRcode(qrcode,vNode){

        let qrcodeCreater = new QRCode(vNode, {
          text: qrcode,
          colorDark: '#000000',
          colorLight: '#ffffff',
          typeNumber: 4,
          width: 200,
          height: 200,
          correctLevel: QRCode.CorrectLevel.L
        })
        qrcodeCreater._el.title = ""
      },


      //刷新登录
      refreshLogin(){
        if(IsIPMode()){
          window.location.replace(window.location.origin+'/#/login?appKey='+ escape (getStrAppkey(decodeURIComponent(this.$route.query.appKey))))
          window.location.reload()
        }else{
          window.location.href = "/"
        }
      },

      getScanLoginQrcode(){
        reGetQrcode().then(res=>{
          if(res.code == 200) {
            this.scanLoginQrcode(res.data.qrcode)
            this.qrScanLoginCodeChange(res.data.reqId)
          }else{
            snackbarMsg('error',res.message)
          }
        })
      },

      // 扫码登录
      getRefreshScanloginCode(key) {
        if (key == "refresh") {
          this.$refs.qrScanLoginCodeUrl.innerHTML = null
          this.showStale = false
        }
        this.getScanLoginQrcode()
      },

      qrScanLoginCodeChange(scanReqId) {
      },

      //围栏扫码
      getCode(key) {

      },
      //围栏扫码登录
      qrCodeChange() {

      },

      getPhoneCode() {
        if (this.codeText == this.$t('push.sendCode')) {
          this.spinning = true
          let params = {
            reqId:sessionStorage.getItem('reqId'),
            smsType: this.$getSmsModel('login')
          }
          sendSms(params).then(res=>{
            this.spinning = false
            if (res.code == 200) {
              snackbarMsg('success',res.message)
              if(this.codeText == this.$t('push.sendCode')) {
                this.codeText = 60
                let timer = setInterval(()=>{
                  this.codeText--
                  if(this.codeText <= 0) {
                    clearInterval(timer)
                    this.codeText = this.$t('push.sendCode')
                  }
                },1000)
              }
            }else{
              snackbarMsg('error',res.message)
            }
          }).catch(err=> {
            this.spinning = false
          })
        }
      },
      getEmailCode() {
        // this.spinning = true
        if (this.emailText == this.$t('push.sendCode')) {
          this.spinning = true
          let params = {
            reqId:sessionStorage.getItem('reqId'),
            emailType: this.$getEmailModel('login')
          }
          sendEmail(params).then(res=> {
            this.spinning = false
            if (res.code == this.$GLOBA.StatusOK) {
              snackbarMsg('success',res.message)
              this.emailText = 60
              let timer = setInterval(()=>{
                this.emailText--
                if(this.emailText <= 0) {
                  clearInterval(timer)
                  this.emailText = this.$t('push.sendCode')
                }
              },1000)
            }else{
              snackbarMsg('error',res.message)
            }
          }).catch(err=> {
            this.spinning = false
          })
        }
      },
      pushFidoUaf() {
        if (this.uafText == this.$t('push.text')) {
          let params = {reqId: sessionStorage.getItem('reqId')}
          let num = 0
          let pushFidoUafFunc = (params)=>{
            this.loadingButton = false
            pushUaf(params).then(res => {
              if(!params.uafReqId){
                params.uafReqId = res.data
              }
              if (res.code == this.$GLOBA.StatusScanningOK) {
                // 唤起app
                if(num < 1) {
                  let userAgent = navigator.userAgent.toLowerCase();
                  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|xiaomi/.test(userAgent)) {
                    window.location.href = "ftiam://com.ft.iam";
                  }
                  num ++
                }

                this.uafText--
                this.uafInterval = setTimeout(() => {
                  pushFidoUafFunc(params)
                }, 1000)
                this.scanResult(res,this.uafInterval,6)
                if (this.uafText <= 0) {
                  clearTimeout(this.uafInterval)
                  this.uafText = this.$t('push.text')
                }
              } else {
                this.scanResult(res,this.uafInterval,6)
              }
            })
          }
          this.uafText = 60
          pushFidoUafFunc(params)
        }

      },
      fastLoginStart(){
        reqFastLoginStart({reqId:sessionStorage.getItem("reqId")}).then(res=>{
          if(res.code == 200) {
            //換起應用
            this.callApp(res.data)
          }else{
            snackbarMsg('error',res.message)
          }
        })

      },
      //对一些异常的code码进行处理
      actionAbnormalErrorCode(code){
        if(this.abnormalCode.includes(code)){
          this.disableButton = true
          setTimeout(
            ()=>{
              this.refreshLogin()
            },1500
          )
        }
      },
      //轮询结果处理
      scanResult(res,timeOut,key){
        // key 1.自动登录 2.多因素登录 3.账号密码登录 4.otp推送 5.扫码登录 6.Uaf推送 7.绑定账户登录,11,飞天云信令
        if (res.code == 200) {
          if(timeOut){
            clearTimeout(timeOut)
          }
          this.loginSuccess(key, res)
        }else if(res.code == 201) {
          timeOut && clearTimeout(timeOut)
          this.authMfaFunc(res.data.authenticators)
          this.isScanLogin = false
        }else if(res.code == 203){
          //203 扫码登录
          timeOut && clearTimeout(timeOut)
          this.newScanCode(res.data.qrCode)
        } else if (res.code == this.$GLOBA.StatusAcceptedUpdatePwd) {
          // 新用户强制修改密码
          timeOut && clearTimeout(timeOut)
          if(key == 4) {
            this.otpText = this.$t('push.text')
          }
          this.$cookieStore.setCookie('username', sessionStorage.getItem('username'));
          this.constraintPwd(res.data.updatePwdToken)
        }else if(res.code == this.$GLOBA.StatusFound) {
          timeOut && clearTimeout(timeOut)
          setPersistenceCookie('userInfo', res.data.userInfo)
          this.allData = res.data
          this.subForm(res.data)
        }else {
          if (key == 2) {
            if (res.message.indexOf("已锁定") > -1) {
              snackbarMsg('error',this.$t('browser.FIDO2Look'))
            } else if (res.message.indexOf("未启用") > -1) {
              snackbarMsg('error',this.$t('browser.FIDO2Err'))
            } else {
              snackbarMsg('error',res.message)
            }
          } else if (res.code != 422) {
            timeOut && clearTimeout(timeOut)
            if (key == 6) {
              this.uafText = this.$t('push.text')
            } else if (key == 4) {
              this.otpText = this.$t('push.text')
            }
            snackbarMsg('error',res.message)
          }
          this.actionAbnormalErrorCode(res.code)
        }
      },

      //处理一些特别的异常信息　
      //1014 ,515 , 1003

      /**
       *  飞天云信令登录开始
       */
      async fastLogin(){
        let params = {reqId:sessionStorage.getItem('reqId')}
        let fastLoginFunc = (params)=>{
          reqFastLogin(params).then(res=>{
            this.loadingButton = false
            if (res.code == this.$GLOBA.StatusScanningOK) {
              num ++
              this.fastPassInterval = setTimeout(()=>{
                fastLoginFunc(params)
              },1000)
              this.scanResult(res,this.fastPassInterval,11)
              if(num > 60) {
                clearTimeout(this.fastPassInterval)
              }
            } else {
              this.scanResult(res,this.fastPassInterval,11)
            }

          })
        }
        let num = 0
        fastLoginFunc(params)
      },

      /**
       *  飞天云信令登录结
       */
      // 多因素认证判断
      async filterData(params) {
        let typeData = {}
        if(this.showFUSBKey == 'pwd') {
          //pwd
          if(!this.password){
            snackbarMsg('error', this.$t('login.pwdNotEmpty'))
            this.loadingButton = false
            return
          }
          let pwd = await this.$passwordEncryption(this.password)
          let  data =  {
            password: pwd,
            reqId:sessionStorage.getItem('reqId'),
          }
          typeData = {
            data:params?Object.assign(data,params):data,
            apiType: reqLoginPwd
          }
        }else if(this.showFUSBKey == 'ldap'){
          if(!this.password){
            snackbarMsg('error', this.$t('login.pwdNotEmpty'))
            this.loadingButton = false
            return
          }
          let pwd = await this.$passwordEncryption(this.password)
          typeData = {
            data: {
              password: pwd,
              reqId:sessionStorage.getItem('reqId'),
              sourceKey: this.restsObj.key,
              username: sessionStorage.getItem("username")
            },
            apiType: ldapLogin
          }
        }else if (this.showFUSBKey == 'otp') {
          this.otpText = this.$t('login.push')
          //otp
          if (!this.fUSBKeyData) {
            this.loadingButton = false
            snackbarMsg('error', this.$t('login.dynamicPassword'))
            return false
          } else {
            typeData = {
              data: {
                otp: this.fUSBKeyData,
                reqId:sessionStorage.getItem('reqId')
              },
              apiType: checkOtp
            }
          }
        } else if (this.showFUSBKey == 'phoneCode') {
          // 短信验证码登录
          if (!this.phoneCode) {
            this.loadingButton = false
            snackbarMsg('error', this.$t('login.messageAuthenticationCode'))
            return false
          } else {
            typeData = {
              data: {
                phoneCode: this.phoneCode,
                reqId:sessionStorage.getItem('reqId')
              },
              apiType: phoneLogin
            }
          }
        } else if (this.showFUSBKey == 'email') {
          // 邮箱验证码登录
          if (!this.emailCode) {
            this.loadingButton = false
            snackbarMsg('error', this.$t('login.emailCode'))
            return false
          } else {
            typeData = {
              data: {
                reqId:sessionStorage.getItem('reqId'),
                emailCode: this.emailCode
              },
              apiType: emailLogin
            }
          }
        } else if (this.showFUSBKey == 'tempLogin') {
          // 临时认证
          if (!this.tempLoginData) {
            this.loadingButton = false
            snackbarMsg('error', this.$t('login.temporaryPwd'))
            return false
          } else {
            typeData = {
              data: {
                tempToken: this.tempLoginData,
                reqId:sessionStorage.getItem('reqId')
              },
              apiType: tempLogin
            }
          }
        } else {
          this.loadingButton = false
          return false
        }
        return typeData
      },


      /*
     * 非第三方多因素认证
     * */

      multipleFuncAuth(data){
        this.filterData(data).then(typeData => {
          if (typeData && typeData.apiType) {
            typeData.apiType(typeData.data).then(res => {
              this.loadingButton = false
              if(this.showFUSBKey == 'pwd') {
                this.closeAllCapta()
              }
              if (res.code == 200) {
                this.loginSuccess(2, res)
                this.setCookieZeroTrust(res.data.zeroTrust)
              }else if (res.code == 201){
                this.authMfaFunc(res.data.authenticators)
                this.isScanLogin = false
                this.setCookieZeroTrust(res.data.zeroTrust)
              }else if(res.code == 203){
                this.newScanCode(res.data.qrCode)
                this.setCookieZeroTrust(res.data.zeroTrust)
              } else if (res.code == 202) {
                // 新用户强制修改密码
                this.$cookieStore.setCookie('username', this.formData.username);
                this.constraintPwd(res.data.updatePwdToken)
                this.setCookieZeroTrust(res.data.zeroTrust)
              } else if (res.code == this.$GLOBA.StatusFound) {
                this.allData = res.data
                this.subForm(res.data)
                // store.commit('zeroTrust/SET_ZERO_TRUST_STATE',res.data.zeroTrust)
                this.setCookieZeroTrust(res.data.zeroTrust)
              }else if(res.code == 2034){
                this.refreshVerify()
                snackbarMsg('error',res.message)
              } else {
                snackbarMsg('error',res.message)
                this.actionAbnormalErrorCode(res.code)
              }
            })
          } else if (!this.showFUSBKey) {
            this.loadingButton = false
            snackbarMsg('error',this.$t('browser.authenticationMethod'))
          }
        })



      },

      setCookieZeroTrust(type){
        this.$cookieStore.setCookie('zeroTrust', type)
      },

      refreshVerify(){
        this.captchaType = ""
        reqGet({reqId:sessionStorage.getItem('reqId')}).then(res => {
          if(res.code == 200) {
            if(res.data.verifyCodeMode > 0) {
              this.captchaType = res.data.verifyCodeMode == 1 ? 'blockPuzzle' : res.data.verifyCodeMode == 2 ? 'clickWord' : 'calculateAnswer'
              this.verificationData = {
                originalImageBase64:res.data.originalImageBase64,
                secretKey:res.data.secretKey,
                token:res.data.token
              }
              if( res.data.verifyCodeMode == 1) {
                this.verificationData.jigsawImageBase64 = res.data.jigsawImageBase64
              }
              if( res.data.verifyCodeMode == 2) {
                this.verificationData.wordList = res.data.wordList
              }
              this.$refs.verifyBox.useVerify()
            }
          }else{
            this.actionAbnormalErrorCode(res.code)
          }
        })
      },

      closeVerifyBox(){
        this.$refs.verifyBox.$refs.verify.closeBox()
        this.loadingButton = false
      },
      closeAllCapta(){
        this.closeVerifyBox()
      },
      editSubmit() {
        setTimeout(()=>{
          this.refreshLogin()
        },500)

        // this.password = ""
        // this.isType = null
        // this.isLdap = false
        // this.showFUSBKey = null
        // this.formData = {}
        // this.isLogin = false
      },
      // 强制改密
      constraintPwd(updatePwdToken) {
        this.visible = false
        this.isType = 'editPwd'
        this.editToken = updatePwdToken
      },
      // 子账号判断
      subForm(val) {
        if(val.type) {
          val.appType = val.type
        }
        // val.subAccountList判断 子账号为空默认传用户名，一个子账号默认传子账号subusername，多个子账号跳转到子账号页面
        if (!val.subAccountList || val.subAccountList.length == 0) {
          if(val.appType == 36 || val.protocolType == 32 ) {
            this.$router.push({
              path: "/downSapPage",
              query: {
                appKey: this.allData.appKey,
                appType: val.appType,
                protocolType:val.protocolType
              },
            })
          }else{
            window.open(val.redirectUrl, "_self")
          }
        } else if (val.subAccountList.length == 1 ) {
          if(val.appType == 36  || val.protocolType == 32 ) {
            this.$router.push({
              path: "/downSapPage",
              query: {
                appKey: val.appKey,
                appType: val.appType,
                protocolType: val.protocolType,
                subUsername: val.subAccountList[0].subusername
              },
            })

          }else {
            window.open(val.redirectUrl+'/'+val.subAccountList[0].subusername, "_self")
          }
          //  this.isLoading = false
        } else {
          this.$router.replace('/subAccount?appKey='+val.appKey+"&&rowData="+this.encode(JSON.stringify(val.subAccountList)))
          this.isLoading = false
        }
      },
      encode(str){
        // 对字符串进行编码
        var encode = encodeURI(str);
        // 对编码的字符串转化base64
        var base64 = btoa(encode);
        return base64;
      },
      // 登录成功后判断
      loginSuccess(key, val) {
        // redirectUrl判断其他网页登录，跳转到redirectUrl网页
        if(window.location.href.indexOf("redirectUrl") > -1) {
          this.urlFilter()
        } else {
          setUserExpriationTip(val.data.sessionEffectivelyTime)
          setPersistenceCookie('outRemindTime', (val.data.remindTime)*60)
          setPersistenceCookie('userInfo', val.data.userInfo)
          setPersistenceCookie('noticePullInterval', val.data.noticePullInterval)
          setPersistenceCookie('passwordRolu', val.data.pwdRule)
          setPersistenceCookie('userAttr', val.data.userAttr)

          // console.log(val)
          // 登录成功后存入零信任是否显示
          this.setCookieZeroTrust(val.data.zeroTrust)
          // key 1.自动登录 2.多因素登录 3.账号密码登录 4.otp推送 5.扫码登录 6.Uaf推送 7.绑定账户登录
          if(IsIPMode()){
            this.$router.push("/adhibition?appKey="+this.$route.query.appKey)
          }else{
            this.$router.push("/adhibition")
          }
          switch(key) {
            case 2:
            case 5:
            case 7:
              snackbarMsg('success',this.$t('login.loginSuccess'))
              break;
            case 3:
              this.visible = false
              snackbarMsg('success',this.$t('login.loginSuccess'))
              break;
            case 4:
              snackbarMsg('success',this.$t('login.loginSuccess'))
              this.otpText = this.$t('push.text')
              break;
            case 6:
              snackbarMsg('success',this.$t('login.loginSuccess'))
              this.uafText = this.$t('push.text')
              break;
          }
        }
      },
      urlFilter() {
        // window.open(decodeURIComponent(window.location.href.match(/redirectUrl=(\S*)/)[1]), "_self")
        let urls = decodeURIComponent(window.location.href.match(/redirectUrl=(\S*)/)[1]) // 获取外部http所有信息
        let str = '' //处理后的数据集合
        if(urls.indexOf("?") > -1) { // 判断是否有参数
          let num1 = urls.split("?")[0] // 域名地址
          let num2 = urls.split("?")[1] // 所有的参数集合
          // 判断是否有第二个参数
          if (num2.indexOf("&") > -1) {
            for (let item of num2.split("&")) {
              if (item.indexOf("=") > -1) {
                let y1 = item.slice(0, item.indexOf("="))
                // 参数编码
                let y2 = encodeURIComponent(item.slice(item.indexOf("=")+1))
                let y3 = y1+'='+y2+"&"
                str += y3
              }
            }
            str = num1 +'?'+ str.slice(0, str.length-1)
          } else {
            // 一个参数直接拼接
            let y1 = num2.slice(0, num2.indexOf("="))
            let y2 = encodeURIComponent(num2.slice(num2.indexOf("=")+1))
            str = num1 +'?'+ y1+'='+y2
          }
        } else {
          str = urls
        }
        window.open(str, "_self")
      },
      fiao2Auth(){
        let self = this
        fido2AuthStart({reqId:sessionStorage.getItem('reqId')}).then(apiResponseData=> {
          this.loadingButton = false
          return new Promise(function(resolve, reject) {
            var returnInfo = {};
            if (apiResponseData.code != 200) {
              snackbarMsg('error', apiResponseData.message)
            } else {
              var businessData = apiResponseData.data

              var reqid = businessData.reqId;
              var fido2_data = JSON.parse(businessData.fido2Data)

              var requestOptions = {};
              requestOptions.challenge = base64urlDecode(fido2_data.challenge);
              if ('timeout' in fido2_data) {
                requestOptions.timeout = fido2_data.timeout;
              }
              if ('rpId' in fido2_data) {
                requestOptions.rpId = fido2_data.rpId;
              }

              if ('allowCredentials' in fido2_data) {
                requestOptions.allowCredentials = self.credentialListConversion(fido2_data.allowCredentials);
              }

              if (typeof navigator.credentials.get !== "function") {
                snackbarMsg('error',self.$t('browser.errorAuthentication'))
              }
              navigator.credentials.get({
                "publicKey": requestOptions
              }).then(function(assertion) {
                var authConfirmFido2Data = {};
                if ('id' in assertion) {
                  authConfirmFido2Data.id = assertion.id;
                }
                if ('type' in assertion) {
                  authConfirmFido2Data.type = assertion.type;
                }
                if ('rawId' in assertion) {
                  authConfirmFido2Data.rawId = assertion.rawId;
                }
                if ('response' in assertion) {
                  var response = {};
                  response.clientDataJSON = base64urlEncode(assertion.response.clientDataJSON);
                  response.authenticatorData = base64urlEncode(assertion.response.authenticatorData);
                  response.signature = base64urlEncode(assertion.response.signature);
                  response.userHandle = base64urlEncode(assertion.response.userHandle);
                  authConfirmFido2Data.response = response;
                  authConfirmFido2Data.username = sessionStorage.getItem('username');
                  resolve(self.authConfirm(authConfirmFido2Data, reqid));
                }
              }).catch(function(err) {
                if (err.toString().indexOf("A request is already pending") > -1){
                  snackbarMsg('error',self.$t('browser.arouse'))
                }else{
                  snackbarMsg('error',self.$t('browser.overtime'))
                }

              });
            }
          });
        })

      },


      credentialListConversion(list) {
        var result = [];
        for (var i = 0; i < list.length; i++) {
          var credential = {};
          credential.type = list[i].type;
          credential.id = base64urlDecode(list[i].id);
          if ('transports' in list) {
            credential.transports = list.transports;
          }
          result.push(credential);
        }
        return result;
      },
      authConfirm(authConfirmFido2Data, reqid) {
        this.loadingButton = false
        fido2AuthConfirm({
          fido2ReqId: reqid,
          reqId:sessionStorage.getItem('reqId'),
          fido2Data: JSON.stringify(authConfirmFido2Data),
          username: sessionStorage.getItem('username')
        }).then(res=> {
          this.scanResult(res,null,2)
        })
      },
      languagesChange() {
        this.spinning = true
        if( this.$cookieStore.getCookie('lang') == "zh") {
          this.$i18n.locale = 'en'
          this.$cookieStore.setCookie('lang', 'en',86400*365)
          this.$cookieStore.setCookie('Accept-Language-User', "en-US",10*365*24*60*60)
        } else {
          this.$i18n.locale = 'zh'
          this.$cookieStore.setCookie('lang', 'zh',86400*365)
          this.$cookieStore.setCookie('Accept-Language-User',"zh-CN",10*365*24*60*60)
        }
        this.languages = this.$cookieStore.getCookie('lang') == "en" ? "Chinese" : "英文"
        // 暴露更新语言接口
        this.$root.eventHub.$emit('languagesChange')
        location.reload();
      },
      removeAd() {
        this.showAd = false
      },
      gotoAd(news,cover,type) {
        console.log(222);
        let routeUrl = this.$router.resolve({
          path:'/loginAd',
          query:{news:news,type:type,base:cover}
        })
        window.open(routeUrl.href, '_blank');
      }

    },
  }
</script>

<style lang='scss' scoped>
  .header-box{
    height: 86px;
    background: #FFFFFF;
  }

  .header-box .header-content{
    height: 86px;
    display: flex;
    align-items: center;
    width: 1100px;
    margin: 0 auto;
  }

  .header-box .website-name{
    display: flex;
  }

  .header-box .website-name .logo{
    width: 60px;
    height: 60px;
    background: url("../../assets/images/images/logo.png") no-repeat;
    background-size: 100% 100%;
    margin-right:7px;
  }

  .header-box .website-name .text-wrap .title{
    /*width: 218px;*/
    height: 28px;
    background: #004CA0;
    text-align: center;
    line-height: 28px;
    color: #FFFFFF;
    font-size: 18px;
    letter-spacing: 2px;
    margin-bottom: 2px;
    text-align: center;
  }

  .header-box .website-name .text-wrap .sub-title{
    font-size: 24px;
    color: #004CA0;
    line-height: 30px;
  }



  .page-login {
    height: 100%;
  }
  .ant-tooltip-arrow {
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    left: 50%;

    bottom: -0.66412vw;
    position: absolute;
    display: block;
    width: 0.68078vw;
    height: 0.68078vw;
    overflow: hidden;
    background: transparent;
    pointer-events: none;
  }
  .ant-tooltip-arrow::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 0.34042rem;
    height: 0.34042rem;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.75);
    -webkit-box-shadow: 0.15625vw 0.15625vw 0.36458vw rgba(0, 0, 0, 0.07);
    box-shadow: 0.15625vw 0.15625vw 0.36458vw rgba(0, 0, 0, 0.07);
    -webkit-transform: translateY(-0.34039vw) rotate(45deg);
    transform: translateY(-0.34039vw) rotate(45deg);
    content: '';
    pointer-events: auto;
  }

  @media (max-width: 700px) {
    .ant-tooltip-arrow {
      overflow: hidden;
      bottom: -0.2102rem;
      width: 0.30042rem;
      height: 0.30042rem;

    }
    .ant-tooltip-arrow::before{
      width: 0.30042rem;
      height: 0.30042rem;
      background-color: rgba(0, 0, 0, 0.70);

    }

  }
  @media (max-width: 550px) {
    .ant-tooltip-arrow {
      bottom: -0.172rem;
      width: 0.30042rem;
      height: 0.2542rem;
      overflow: hidden;
    }
    .ant-tooltip-arrow::before{
      width: 0.30042rem;
      height: 0.30042rem;

    }
  }

  .login-box {
    height: 100%;
    // min-height: 900px;
    // background: linear-gradient(143deg, #2E6BF7, #2EB7F7);
    display: flex;
    position: relative;
    .logo {
      position: absolute;
      top: 30px;
      left: 40px;
      height: 110px;
      width: 240px;
    }
    .tabs-box ::v-deep {
      // padding: 0 100px;
      text-align: center;
      .ant-tabs-bar {
        border: 0;
        margin: 10px 0 40px;
      }
      .ant-tabs-tab {
        font-size: 20px;
      }
      .ant-tabs-tab-active {
        color: #5066e0;
      }
      .ant-tabs-ink-bar {
        background: #5066e0;
      }
    }
    .ldap-title {
      margin: 40px 0 40px;
      font-size: 18px;
      text-align: center;
    }
    .pwd-box {
      // padding: 0 100px;
      // max-width: 380px;
      margin: 0 auto;
      .fusb-Key {
        /*display: flex;*/
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .fido-u2f {
        font-size: 14px;
        color: #666;
        line-height: 24px;
        text-align: center;
      }
      .fido-uaf {
        justify-content: flex-end;
      }
      .more-input {
        font-size: 16px;
        height: 50px;
        border-radius: 30px;
        padding-left: 30px;
        background-color: #f5f5f5;
        border:none;
      }
      .more-input:focus {
        box-shadow: none;
      }
      .key-btn {
        height: 50px;
        width: 180px;
        margin-left: 50px;
        font-size: 18px;
        // background: #337DF7;
        border-radius: 25px;
      }

    }
    .ant-input-password ::v-deep {
      .ant-input-suffix {
        right: 20px;
      }

    }
    .scan-login-code-box {
      position: relative;
      height: 270px;
      margin: 0px auto;
      /*display: flex;*/
      .code {
        width: 100%;
        height: 260px;
        margin-bottom: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

      }
      .code-box_txt{

        text-align: center;
      }
      .stale-box, .qr-success-text {
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        width: 250px;
        height: 260px;
        background-color: rgba(255,255,255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 16px;
        a {
          text-decoration: underline;
        }
        .qr-text {
          padding: 10px 0;
          font-weight: bold;
        }
      }
    }
    .code-box ::v-deep {
      position: relative;
      width: 340px;
      height: 380px;
      margin: 30px auto 20px;
      margin-bottom: 30px;
      display: flex;
      justify-content: center;
      background: #FFFFFF;
      padding: 21px;
      box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.16);
      img {
        width: 200px;
        margin: 0 auto;
        position: absolute;
        top: 56px;
      }
      .stale-img {
        width: 64px;
        height: 64px;
        left: 35%;

      }
      .text {
        margin-top: 10px;
        text-align: center;

      }
      .stale-box, .qr-success-text {
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        width: 220px;
        height: 220px;
        background-color: rgba(255,255,255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 16px;
        a {
          text-decoration: underline;
        }
        .qr-text {
          margin-top: 85px;
          padding: 10px 0;
          font-weight: bold;
          font-size: 16px;
          color:#666;
          text-align: center;
        }
      }
      .qr-success-text {
        text-align: center;
        // margin-top: 25px;
        font-weight: bold;
        .s-title {
          font-size: 18px;
          margin-bottom: 3px;
          margin-top: 20px;
        }
      }
      .code-box_txt{
        position: absolute;
        bottom: 28px;
        text-align: center;
        font-size: 13px;
      }
      .code {
        margin-top: 36px;
      }
    }
    .box {
      // margin: 100px 100px 65px;
      /*background: #FFFFFF;*/
      box-shadow: 0px 15px 50px 0px rgba(103, 182, 206, 0.27);
      // border-radius: 20px;
      flex: 1;
      display: flex;
      // padding-top: 120px;
      // width: 100%;
      .login-icon {
        width: 100%;
        z-index: 1;
      }
      .img-box {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .login-title-icon {
        position: absolute;
        z-index: 1;
        height: 100%;
        right: 0;
        width: 100%;
        top: 0;
      }
      .right-box {
        // flex: 1;
        // min-width: 380px;
        width:382px;
        // padding-top:12%;
        // margin-left: 195px;
        // margin-right: -85px;
        z-index: 15;
        .login-title {
          // height: 70px;
          // line-height: 70px;
          // padding-left: 95px;
          // border-bottom: 1px solid rgba(0,0,0,.12);
          font-size: 34px;
          font-weight: 400;
          text-align: left;
          margin-bottom: 40px;

        }
        .sub-title {
          font-size: 18px;
          font-weight: 600;
          color: #337DF7;
          padding: 70px 0 50px;
          text-align: center;
        }
        .login-btn {
          width: 100%;
          height: 50px !important;
          line-height: 50px;
          background: transparent;
          // box-shadow: 0px 6px 12px 0px rgba(42, 154, 243, 0.35);
          font-size: 14px;
          font-weight: 500;
          color: #FFFEFE;
          margin-top: 10px;
          border: 1px solid #5066e0;
        }
        .login-btn[disabled]{
          color: rgba(0, 0, 0, 0.25);
          background-color: #f5f5f5;
          border-color: #d9d9d9;
          text-shadow: none;
          box-shadow: none;
        }
        .sub-btn {
          background: #5066e0;
          font-size: 16px;
        }

      }

      .right-box.auth-maf-content {
        margin: 0 auto;
      }
    }
    .tip {
      font-size: 16px;
      margin-top: 20px;
      font-weight: 500;
      color: #5066e0;
      cursor: pointer;
      .name-pwd {
        float: right;
      }
      a {
        text-decoration: none;
        color: #5066e0;
      }
    }
    .rests-title {
      font-size: 20px;
      font-weight: 400;
      color: #666;
      margin: 20px 0 20px;
      text-align: center;
      span {
        margin: 0 20px;
      }
    }
    .more-title {
      font-size: 16px;
      color: #666;
      margin: 10px -10px 20px;
      text-align: center;
      span {
        margin: 0 5px;
      }
    }
    .more-box {
      text-align: left;
      .img_box{
        display: inline-block;
        height: 41px;
        width: 41px;
        text-align: center;
        line-height: 40px;
        margin: 0 8px 16px;
        position: relative;
        .img_shadow_none{
          position: absolute;
          left: 2px;
          top: 4px;
          width: 36px;
          height: 36px;
          display: none;
        }


      }
      img {
        height: 40px;
        cursor: pointer;
      }
      .img1_normal{
        height: 36px;
      }
    }
    .rests-box {
      text-align: center;
      margin-right: 15px;
      display: flex;
      justify-content: center;
      .auth-source-list {
        width: 45px;
        height: 45px;
        // background: #FFFFFF;
        border-radius: 50%;
        margin: 0 13px 15px;
        cursor: pointer;
        .rests-pic {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          transition: transform 0.5s;
        }
      }
      .auth-source-list:hover .rests-pic {
        transform: scale(1.1);
        box-shadow: 0 6px 12px 0 rgb(42 154 243 / 35%)
      }
    }
  }
  .login-index {
    height: 100%;
    // min-width: 1500px;
    .no-app {
      display: inline-block;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        margin-left: 120px;
      }
      .no-title {
        text-align: center;
        margin-top: 50px;
        font-size: 16px;
      }
    }
  }
  .fastLoginStyle{
    display: inline-block;
    width: 15%;
    height: 50px;
    line-height: 50px;
    background: #5066e0;
    border-radius: 0 5px 5px 0;
    margin-top:10px;
    text-align: center;
    cursor: pointer;
    // top:-1px;
    img {
      vertical-align: middle;
    }
  }
  .spin-box ::v-deep {
    height: 100%;
    .ant-spin-container {
      height: 100%;
    }
  }
  .phone-code ::v-deep {
    .ant-form-item-children {
      display: flex;
    }
  }
  .code-btn ::v-deep {
    .ant-input {
      height: 46px;
      border-radius: 10px 0 0 10px;
      padding-left: 20px;
      font-size: 16px;
      border-right: 0;
      // background-color: #f5f5f5;
      // border: none;
    }
    .ant-input:hover,.ant-input:focus {
      border-right: 1px solid  #40a9ff !important;
    }
    .ant-input:focus {
      box-shadow:none;
    }
    .ant-input-group-addon {
      border-radius: 0 10px 10px 0;
      background-color: #fff;
      // border: none;
    }
    .code-text {
      // border-radius: 0 25px 25px 0;
      padding: 0 30px;
      font-size: 16px;
      text-decoration: none;
      border: 0 !important;
    }
    .code-text:hover,.code-text:focus {
      border: 0;
      outline: none;
    }
  }
  .code-pwd ::v-deep {
    .ant-input {
      height: 46px;
      border-radius:10px;
      /*padding-left: 20px;*/
      font-size: 16px;
      /*border-right: 0;*/
      // background-color: #f5f5f5;
      // border: none;
    }
    /*.ant-input:hover,.ant-input:focus {*/
    /*    border-right: 1px solid  #40a9ff !important;*/
    /*}*/
    /*.ant-input:focus {*/
    /*    box-shadow:none;*/
    /*}*/

    .code-text {
      // border-radius: 0 25px 25px 0;
      padding: 0 30px;
      font-size: 16px;
      text-decoration: none;
      border: 0 !important;
    }

  }
  .ant-divider-horizontal.ant-divider-with-text-center ::v-deep{
    font-size: 14px;
    color: #666;
  }
  .ant-btn-background-ghost.ant-btn-primary ::v-deep{
    border-color: #5066e0;
    // box-shadow: 0px 6px 12px 0px rgba(80, 102, 224,0.35);
  }
  .divider1{
    display: inline-block;
    width: 80px;
    height: 2px;
    opacity: 1;
    background: linear-gradient(to left, rgba(153, 153, 153, 1), rgba(153, 153, 153, 0));
    margin-right: 15px;
  }
  .divider2{
    display: inline-block;
    width: 80px;
    height: 2px;
    opacity: 1;
    background: linear-gradient(to left, rgba(153, 153, 153, 0), rgba(153, 153, 153, 1));
    margin-left: 15px;
  }
  .jiantou{
    display: inline-block;
    width: 63px;
    height: 49px;
    position: absolute;
    right: -2px;
    top: 0;
    background: #5066E0;
    border-radius: 0px 10px 10px 0px;
    opacity: 1;
    border: 1px solid #5066E0;
    line-height: 45px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .authMfa-box {
    min-width: 380px;
    // padding-top:15%;
    // margin-left: 250px;
  }
  .divider-box {
    text-align:center;
    margin-bottom: 32px;
  }
  .go-box {
    margin-right:5px;
    //  position: absolute;
    //  left: 15px;
    //  top: 15px;
  }
  .go_text{
    position: absolute;
    left: 40px;
    top: 1px;
    font-size: 14px;
  }
  .code {
    // margin: 30px auto 20px;
    // display: flex;
    // justify-content: center;
    width: 200px;
    height: 200px;

    // background: #FFFFFF;
    // padding: 21px;
    // box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.16);

  }
  .code-box_bg{
    text-align: center;
    position: absolute;
    width:252px !important;
    top:30px !important;
    // border: 1px dashed #ccc;
  }

  .register-a-link{

    font-size: 16px;
    font-weight: 500;
    color: #5066e0;
    cursor: pointer;
  }
  .languages-box {
    //   position: absolute;
    color:rgba(0,0,0,.65);
    font-size: 14px;
    bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-top: 20px;
    justify-content: center;
    span {
      margin-left: 5px;
    }
  }
  .languages-box:hover {
    color: #333;
  }
  @media screen and (min-width: 320px) and (max-width: 480px){
    .login-box .box .right-box{
      padding: 10px 13px 10px 10px;
    }
    .login-box .more-title{
      font-size: 14px;
      margin: 10px -10px 20px;
      span{
        margin:0 3px;
      }
    }
    .go-box{
      margin-right:1px;
    }
    ::v-deep{
      .theme--light.v-input input{
        font-size: 14px;
      }
    }
    .login-box .more-box img{
      margin: 0 8px 20px;
    }
    .code_phone{
      width: 94% !important;
    }
    .more-box .img_box .img_shadow{
      display: block !important;
    }
    .more-box .img_box .img_shadow_none{
      left: 0px !important;
      top: 0px !important;
    }
  }
  .code_phone{
    width: 118%;
  }
  .login-index-loading-box {
    margin: 120px;text-align: center
  }
  .loading-style {
    margin-top: 40px;
  }
  .login-box-style {
    min-width: 400px;
    max-width: 460px;
    min-height: 60vh;
    background-color: #ffffff;
    border-radius: 10px;
    padding-top: 40px;
    padding-bottom: 40px;
    justify-content: center;
  }
  .advertising {
    position: absolute;
    top: 18%;
    left: 0%;
    height: 53%;
    width: 42%;
    margin-left: 5px;
    .top {
      position: relative;
      width: 100%;
      height: 33%;
      // background-color: skyblue;
      margin-bottom: 10px;
      img {
        cursor: pointer;
        position: absolute;
        top: 1%;
        right: 1%;
      }


    }
    .bottom {
      display: flex;
      justify-content: space-between;
      height: 65%;
      min-height: 280px;
      span:hover {
        color: blue;
      }
      .left {
        width: 49%;
        background-color: #fff;
      }
      .right {
        width: 49%;
        background-color: #fff;
      }
      .title {
        height: 14%;
        width: 100%;
        border-bottom:  1px solid #d9d9d9;
        display: flex;
        align-items: center;
        .name {
          font-size: 16px;
          margin-left: 10px;
        }
      }
      .content-list {
        width: 100%;
        height: 100%;

        padding: 0 10px;

        .content {
          text-align: left;
          font-size: 14px;
          margin-top: 8px;
          width: 100%;
          height: 11.5%;
          border-bottom:  1px solid #d9d9d9;
          .mr {
            margin-right: 10px;
            cursor: pointer;
          }
          .left {
            display: inline-block;
            width:calc(100% - 70px);
            vertical-align: top;

            span {
              display: inline-block;
              max-width:calc(100% - 28px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: top;
              cursor: pointer;
            }
          }
          .right {
            color:gray;
            font-size:12px;
            margin-right: 0px;
          }
        }
        .content:last-child {
          border-bottom: none;
        }
      }

    }
  }

  .login-box-content.new-content {

    padding-top: 104px !important;
    padding-bottom: 97px !important;
    min-height: calc(100vh - 236px) !important;
    box-sizing: unset;
  }
  .login-wrap{
    width: 1200px;
    height: 630px;
    background: url("../../assets/images/images/login-bg.png") no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    padding-top: 14px;
    box-sizing: unset;
  }

  .login-wrap .login-box{
    float: right;
    margin-right: 21px;
    width: 498px;
    height: 600px;
    background: #FFFFFF;
    border-radius: 16px 8px 8px 16px;
    box-sizing: border-box;
  }

  .login-content{
    width: 382px;
    margin: 0 auto;
  }

  .login-wrap .login-box .login-title{
    color: #333333;
    font-size: 34px;
    line-height: 48px;
    padding-top: 63px;
    margin-bottom: 40px;
  }



  .login-wrap .login-box   .form-item{
    position: relative;
    height: 52px;
  }

  .login-wrap .login-box   .form-item .code-img {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    width: 96px;
    height: 42px;
    cursor: pointer;
  }

  .login-wrap .login-box   .form-item .code-img>img{
    display: block;
    width: 100%;
    height: 100%;
  }

  .login-wrap .login-box  .form-item .icon-wrap{
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
  }

  .login-wrap .login-box  .form-item .icon-wrap.icon-user{
    background: url("../../assets/images/images/icon-user.png") no-repeat;
    background-size: 100% 100%;
  }

  .login-wrap .login-box   .form-item .icon-wrap.icon-code{
    background: url("../../assets/images/images/icon-code.png") no-repeat;
    background-size: 100% 100%;
  }

  .login-wrap .login-box   .form-item .icon-wrap.icon-password{
    background: url("../../assets/images/images/icon-password.png") no-repeat;
    background-size: 100% 100%;
  }

  .login-wrap  .form-item {
    ::v-deep .v-input__control {
      border-radius: unset;
      input {
        margin-left: 20px;
      }

    }
  }

  .login-wrap .form-item {
    ::v-deep .v-input__control fieldset{
      border: 0;
      border-bottom: 1px solid #D1D4D8;
      font-size: 20px;
      height: 52px;
      box-sizing: border-box;
      width: 100%;
      padding-left: 40px;
    }
  }



    .login-wrap .login-box   .form-item .input-text{
      border: 0;
      border-bottom: 1px solid #D1D4D8;
      font-size: 20px;
      height: 52px;
      box-sizing: border-box;
      width: 100%;
      padding-left: 40px;
    }

    .login-wrap .login-box   .form-item .input-text::placeholder{
      color:#999999;
    }

    .login-wrap .login-box  .form-item .input-text:focus{
      outline: none;
      border-bottom: 1px solid #D1D4D8;
    }

    .login-wrap .login-box .form-tool .check{
      color: #999999;
      font-size: 14px;
      margin-bottom: 38px;
    }

    .login-wrap .login-box .form-tool .check .icon-check{
      display: inline-block;
      vertical-align: middle;
      width: 14px;
      height: 14px;
      background: url("../../assets/images/images/icon-check-default.png") no-repeat;
      background-size: 100% 100%;
      margin-top: -3px;
      margin-right: 3px;
      appearance: none;
      -webkit-appearance: none;
    }

    .login-wrap .login-box .form-tool .check .icon-check.active,
    .login-wrap .login-box .form-tool .check .icon-check:checked{
      background: url("../../assets/images/images/icon-check-active.png") no-repeat;
      background-size: 100% 100%;
    }

    .login-wrap .login-box .form-tool .check>a{
      color: #326DF3;
      font-size: 14px;
    }

    .login-wrap .login-box .login-btn{
      display: block;
      width: 382px;
      height: 54px !important;
      background: #004CA0;
      border-radius: 4px;
      text-align: center;
      line-height: 54px;
      color: #FFFFFF;
      font-size: 22px;
      margin-bottom: 17px;
    }

    .login-wrap .login-box .login-btn:hover{
      opacity: 0.9;
    }

    .login-wrap .login-box .other-login{
      text-align: right;
    }

    .login-wrap .login-box .other-login>a{
      color:#326DF3;
      font-size: 16px;
      text-decoration: underline;
    }

    .footer-box {
      background: #1E2C45;
      text-align: center;
      padding-top: 22px;
      color: #FFFFFF;
      padding-bottom: 28px;
    }

    .footer-box .friend-link {
      font-size: 14px;
      color: #FFFFFF;
      line-height: 28px;
      margin-bottom: 15px;
    }

    .footer-box .friend-link > a {
      text-decoration: underline;
      margin-right: 15px;
      color: #FFFFFF;
    }

    .footer-box .container > p {
      font-size: 12px;
      color: #FFFFFF;
      line-height: 28px;
    }

    .footer-box .container > p .text {
      color: #FFFFFF;
      margin-left: 10px;
      margin-right: 10px;
    }


</style>
